import { apiGet, apiPost } from "../shared/apiClient";

// Single GET, parameterized differently by each caller: the board's own
// date/agent/search fetch (QuerysetV4.js), and a plain {customer_id} lookup
// reused by the chat drawer's "View Queries" tab and the customer profile
// drawer's Queries tab. One generic query-string builder covers all of it.
export function fetchQueries(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    // The authenticated token is the sole source of the current actor. Keep
    // old callers from accidentally reviving the retired identity override.
    if (key === "user_id") return;
    if (value !== undefined && value !== null && value !== "") qs.set(key, value);
  });
  return apiGet(`/queryset_v2/get?${qs}`)
    .then(res => (res.data?.success ? (res.data.data || []) : []))
    .catch(() => []);
}

// Callers branch on res.data.success/res.data.message themselves (e.g. to
// throw a specific error), so the raw payload is returned as-is.
export function createQuery(payload) {
  return apiPost("/queryset_v2/create", payload).then(res => res.data);
}

export function updateDraft(payload) {
  return apiPost("/queryset_v2/update_draft", payload).then(res => res.data);
}

export function updateUrgency(taskId, urgency) {
  return apiPost("/query_workflow/update_urgency", { task_id: taskId, urgency }).then(res => res.data);
}

// Overwrites created_at with now; the original value is preserved
// server-side in the task's timeline, not here. See
// docs/superpowers/specs/2026-07-27-bring-query-to-today-design.md.
export function bringQueryToToday(taskId, userId) {
  return apiPost("/queryset_v2/bring_to_today", { task_id: taskId, user_id: userId }).then(res => res.data);
}

export function fetchFollowupsDue() {
  return apiGet("/query_workflow/followups_due")
    .then(res => (res.data?.success ? (res.data.data || []) : []))
    .catch(() => []);
}

export function fetchCancelledAfterSalesRecords() {
  return apiGet("/query_after_sales/get?purchase_status=cancelled")
    .then(res => (res.data?.success ? (res.data.data || []) : []))
    .catch(() => []);
}

// Pending quote-approval requests, keyed by query_pk for O(1) badge lookup
// on the board — mirrors QuerysetV4.js's own map-building right after fetch.
export function fetchActiveApprovals() {
  return apiGet("/queries/approvals/active")
    .then(res => {
      const map = {};
      (res.data?.data ?? []).forEach(a => { map[a.query_pk] = a; });
      return map;
    })
    .catch(() => ({}));
}

export function approveApproval(approvalId, payload) {
  return apiPost(`/queries/approvals/${approvalId}/approve`, payload).then(res => res.data);
}

export function rejectApproval(approvalId, payload) {
  return apiPost(`/queries/approvals/${approvalId}/reject`, payload).then(res => res.data);
}
